"use strict";
/* tslint:disable */
/* eslint-disable */
/*
Carbon

Connect external data to LLMs, no matter the source.

The version of the OpenAPI document: 1.0.0


NOTE: This file is auto generated by Konfig (https://konfigthis.com).
*/
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilesApiGenerated = exports.FilesApiFactory = exports.FilesApiFp = exports.FilesApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
const browser_1 = require("file-type/browser");
const FormData = require("form-data");
// @ts-ignore
const base_1 = require("../base");
const requestBeforeHook_1 = require("../requestBeforeHook");
/**
 * FilesApi - axios parameter creator
 * @export
 */
const FilesApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * A tag is a key-value pair that can be added to a file. This pair can then be used for searches (e.g. embedding searches) in order to narrow down the scope of the search. A file can have any number of tags. The following are reserved keys that cannot be used: - db_embedding_id - organization_id - user_id - organization_user_file_id  Carbon currently supports two data types for tag values - `string` and `list<string>`. Keys can only be `string`. If values other than `string` and `list<string>` are used, they\'re automatically converted to strings (e.g. 4 will become \"4\").
         * @summary Create File Tags
         * @param {OrganizationUserFileTagCreate} organizationUserFileTagCreate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserFileTags: (organizationUserFileTagCreate, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationUserFileTagCreate' is not null or undefined
            (0, common_1.assertParamExists)('createUserFileTags', 'organizationUserFileTagCreate', organizationUserFileTagCreate);
            const localVarPath = `/create_user_file_tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: organizationUserFileTagCreate,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/create_user_file_tags',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organizationUserFileTagCreate, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete File Endpoint
         * @param {number} fileId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        delete: (fileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fileId' is not null or undefined
            (0, common_1.assertParamExists)('delete', 'fileId', fileId);
            const localVarPath = `/deletefile/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId !== undefined ? fileId : `-file_id-`)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'DELETE' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/deletefile/{file_id}',
                httpMethod: 'DELETE'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete File Tags
         * @param {OrganizationUserFileTagsRemove} organizationUserFileTagsRemove
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFileTags: (organizationUserFileTagsRemove, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationUserFileTagsRemove' is not null or undefined
            (0, common_1.assertParamExists)('deleteFileTags', 'organizationUserFileTagsRemove', organizationUserFileTagsRemove);
            const localVarPath = `/delete_user_file_tags`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: organizationUserFileTagsRemove,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/delete_user_file_tags',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organizationUserFileTagsRemove, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete Files Endpoint
         * @param {DeleteFilesQueryInput} deleteFilesQueryInput
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteMany: (deleteFilesQueryInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'deleteFilesQueryInput' is not null or undefined
            (0, common_1.assertParamExists)('deleteMany', 'deleteFilesQueryInput', deleteFilesQueryInput);
            const localVarPath = `/delete_files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: deleteFilesQueryInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/delete_files',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteFilesQueryInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Delete Files V2 Endpoint
         * @param {DeleteFilesV2QueryInput} deleteFilesV2QueryInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV2: (deleteFilesV2QueryInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'deleteFilesV2QueryInput' is not null or undefined
            (0, common_1.assertParamExists)('deleteV2', 'deleteFilesV2QueryInput', deleteFilesV2QueryInput);
            const localVarPath = `/delete_files_v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: deleteFilesV2QueryInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/delete_files_v2',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(deleteFilesV2QueryInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This route is deprecated. Use `/user_files_v2` instead.
         * @summary Parsed File
         * @param {number} fileId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getParsedFile: (fileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fileId' is not null or undefined
            (0, common_1.assertParamExists)('getParsedFile', 'fileId', fileId);
            const localVarPath = `/parsed_file/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId !== undefined ? fileId : `-file_id-`)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/parsed_file/{file_id}',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This route is deprecated. Use `/user_files_v2` instead.
         * @summary Raw File
         * @param {number} fileId
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRawFile: (fileId, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'fileId' is not null or undefined
            (0, common_1.assertParamExists)('getRawFile', 'fileId', fileId);
            const localVarPath = `/raw_file/{file_id}`
                .replace(`{${"file_id"}}`, encodeURIComponent(String(fileId !== undefined ? fileId : `-file_id-`)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/raw_file/{file_id}',
                httpMethod: 'GET'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Modify Cold Storage Parameters
         * @param {ModifyColdStorageParametersQueryInput} modifyColdStorageParametersQueryInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyColdStorageParameters: (modifyColdStorageParametersQueryInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'modifyColdStorageParametersQueryInput' is not null or undefined
            (0, common_1.assertParamExists)('modifyColdStorageParameters', 'modifyColdStorageParametersQueryInput', modifyColdStorageParametersQueryInput);
            const localVarPath = `/modify_cold_storage_parameters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: modifyColdStorageParametersQueryInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/modify_cold_storage_parameters',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(modifyColdStorageParametersQueryInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Move To Hot Storage
         * @param {MoveToHotStorageQueryInput} moveToHotStorageQueryInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveToHotStorage: (moveToHotStorageQueryInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'moveToHotStorageQueryInput' is not null or undefined
            (0, common_1.assertParamExists)('moveToHotStorage', 'moveToHotStorageQueryInput', moveToHotStorageQueryInput);
            const localVarPath = `/move_to_hot_storage`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: moveToHotStorageQueryInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/move_to_hot_storage',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(moveToHotStorageQueryInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * For pre-filtering documents, using `tags_v2` is preferred to using `tags` (which is now deprecated). If both `tags_v2` and `tags` are specified, `tags` is ignored. `tags_v2` enables building complex filters through the use of \"AND\", \"OR\", and negation logic. Take the below input as an example: ```json {     \"OR\": [         {             \"key\": \"subject\",             \"value\": \"holy-bible\",             \"negate\": false         },         {             \"key\": \"person-of-interest\",             \"value\": \"jesus christ\",             \"negate\": false         },         {             \"key\": \"genre\",             \"value\": \"religion\",             \"negate\": true         }         {             \"AND\": [                 {                     \"key\": \"subject\",                     \"value\": \"tao-te-ching\",                     \"negate\": false                 },                 {                     \"key\": \"author\",                     \"value\": \"lao-tzu\",                     \"negate\": false                 }             ]         }     ] } ``` In this case, files will be filtered such that: 1. \"subject\" = \"holy-bible\" OR 2. \"person-of-interest\" = \"jesus christ\" OR 3. \"genre\" != \"religion\" OR 4. \"subject\" = \"tao-te-ching\" AND \"author\" = \"lao-tzu\"  Note that the top level of the query must be either an \"OR\" or \"AND\" array. Currently, nesting is limited to 3. For tag blocks (those with \"key\", \"value\", and \"negate\" keys), the following typing rules apply: 1. \"key\" isn\'t optional and must be a `string` 2. \"value\" isn\'t optional and can be `any` or list[`any`] 3. \"negate\" is optional and must be `true` or `false`. If present and `true`, then the filter block is negated in the resulting query. It is `false` by default.
         * @summary User Files V2
         * @param {OrganizationUserFilesToSyncQueryInput} organizationUserFilesToSyncQueryInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryUserFiles: (organizationUserFilesToSyncQueryInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationUserFilesToSyncQueryInput' is not null or undefined
            (0, common_1.assertParamExists)('queryUserFiles', 'organizationUserFilesToSyncQueryInput', organizationUserFilesToSyncQueryInput);
            const localVarPath = `/user_files_v2`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: organizationUserFilesToSyncQueryInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/user_files_v2',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organizationUserFilesToSyncQueryInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This route is deprecated. Use `/user_files_v2` instead.
         * @summary User Files
         * @param {OrganizationUserFilesToSyncQueryInput} organizationUserFilesToSyncQueryInput
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        queryUserFilesDeprecated: (organizationUserFilesToSyncQueryInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'organizationUserFilesToSyncQueryInput' is not null or undefined
            (0, common_1.assertParamExists)('queryUserFilesDeprecated', 'organizationUserFilesToSyncQueryInput', organizationUserFilesToSyncQueryInput);
            const localVarPath = `/user_files`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: organizationUserFilesToSyncQueryInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/user_files',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(organizationUserFilesToSyncQueryInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Resync File
         * @param {ResyncFileQueryInput} resyncFileQueryInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resync: (resyncFileQueryInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'resyncFileQueryInput' is not null or undefined
            (0, common_1.assertParamExists)('resync', 'resyncFileQueryInput', resyncFileQueryInput);
            const localVarPath = `/resync_file`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: resyncFileQueryInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/resync_file',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(resyncFileQueryInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * This endpoint is used to directly upload local files to Carbon. The `POST` request should be a multipart form request. Note that the `set_page_as_boundary` query parameter is applicable only to PDFs for now. When this value is set, PDF chunks are at most one page long. Additional information can be retrieved for each chunk, however, namely the coordinates of the bounding box around the chunk (this can be used for things like text highlighting). Following is a description of all possible query parameters: - `chunk_size`: the chunk size (in tokens) applied when splitting the document - `chunk_overlap`: the chunk overlap (in tokens) applied when splitting the document - `skip_embedding_generation`: whether or not to skip the generation of chunks and embeddings - `set_page_as_boundary`: described above - `embedding_model`: the model used to generate embeddings for the document chunks - `use_ocr`: whether or not to use OCR as a preprocessing step prior to generating chunks. Valid for PDFs, JPEGs, and PNGs - `generate_sparse_vectors`: whether or not to generate sparse vectors for the file. Required for hybrid search. - `prepend_filename_to_chunks`: whether or not to prepend the filename to the chunk text   Carbon supports multiple models for use in generating embeddings for files. For images, we support Vertex AI\'s multimodal model; for text, we support OpenAI\'s `text-embedding-ada-002` and Cohere\'s embed-multilingual-v3.0. The model can be specified via the `embedding_model` parameter (in the POST body for `/embeddings`, and a query  parameter in `/uploadfile`). If no model is supplied, the `text-embedding-ada-002` is used by default. When performing embedding queries, embeddings from files that used the specified model will be considered in the query. For example, if files A and B have embeddings generated with `OPENAI`, and files C and D have embeddings generated with `COHERE_MULTILINGUAL_V3`, then by default, queries will only consider files A and B. If `COHERE_MULTILINGUAL_V3` is specified as the `embedding_model` in `/embeddings`, then only files C and D will be considered. Make sure that the set of all files you want considered for a query have embeddings generated via the same model. For now, **do not** set `VERTEX_MULTIMODAL` as an `embedding_model`. This model is used automatically by Carbon when it detects an image file.
         * @summary Create Upload File
         * @param {Uint8Array | File | buffer.File} file
         * @param {BodyCreateUploadFileUploadfilePost} bodyCreateUploadFileUploadfilePost
         * @param {number} [chunkSize] Chunk size in tiktoken tokens to be used when processing file.
         * @param {number} [chunkOverlap] Chunk overlap in tiktoken tokens to be used when processing file.
         * @param {boolean} [skipEmbeddingGeneration] Flag to control whether or not embeddings should be generated and stored             when processing file.
         * @param {boolean} [setPageAsBoundary] Flag to control whether or not to set the a page\&#39;s worth of content as the maximum             amount of content that can appear in a chunk. Only valid for PDFs. See description route description for             more information.
         * @param {EmbeddingModel} [embeddingModel] Embedding model that will be used to embed file chunks.
         * @param {boolean} [useOcr] Whether or not to use OCR when processing files. Valid for PDFs, JPEGs, and PNGs. Useful for documents with             tables, images, and/or scanned text.
         * @param {boolean} [generateSparseVectors] Whether or not to generate sparse vectors for the file. This is *required* for the file to be a             candidate for hybrid search.
         * @param {boolean} [prependFilenameToChunks] Whether or not to prepend the file\&#39;s name to chunks.
         * @param {number} [maxItemsPerChunk] Number of objects per chunk. For csv, tsv, xlsx, and json files only.
         * @param {boolean} [parsePdfTablesWithOcr] Whether to use rich table parsing when &#x60;use_ocr&#x60; is enabled.
         * @param {boolean} [detectAudioLanguage] Whether to automatically detect the language of the uploaded audio file.
         * @param {TranscriptionServiceNullable} [transcriptionService] The transcription service to use for audio files. If no service is specified, \&#39;deepgram\&#39; will be used.
         * @param {boolean} [includeSpeakerLabels] Detect multiple speakers and label segments of speech by speaker for audio files.
         * @param {FileContentTypesNullable} [mediaType] The media type of the file. If not provided, it will be inferred from the file extension.
         * @param {boolean} [splitRows] Whether to split tabular rows into chunks. Currently only valid for CSV, TSV, and XLSX files.
         * @param {boolean} [enableColdStorage] Enable cold storage for the file. If set to true, the file will be moved to cold storage after a certain period of inactivity. Default is false.
         * @param {number} [hotStorageTimeToLive] Time in days after which the file will be moved to cold storage. Must be one of [1, 3, 7, 14, 30].
         * @param {boolean} [generateChunksOnly] If this flag is enabled, the file will be chunked and stored with Carbon,             but no embeddings will be generated. This overrides the skip_embedding_generation flag.
         * @param {boolean} [storeFileOnly] If this flag is enabled, the file will be stored with Carbon, but no processing will be done.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload: (file, bodyCreateUploadFileUploadfilePost, chunkSize, chunkOverlap, skipEmbeddingGeneration, setPageAsBoundary, embeddingModel, useOcr, generateSparseVectors, prependFilenameToChunks, maxItemsPerChunk, parsePdfTablesWithOcr, detectAudioLanguage, transcriptionService, includeSpeakerLabels, mediaType, splitRows, enableColdStorage, hotStorageTimeToLive, generateChunksOnly, storeFileOnly, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'file' is not null or undefined
            (0, common_1.assertParamExists)('upload', 'file', file);
            // verify required parameter 'bodyCreateUploadFileUploadfilePost' is not null or undefined
            (0, common_1.assertParamExists)('upload', 'bodyCreateUploadFileUploadfilePost', bodyCreateUploadFileUploadfilePost);
            const localVarPath = `/uploadfile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();
            const addFormParam = (name, data, isBinary, isPrimitiveType) => __awaiter(this, void 0, void 0, function* () {
                if (isBinary) {
                    if (data instanceof Uint8Array) {
                        // Handle Buffer data
                        const filetype = yield (0, browser_1.fromBuffer)(data);
                        const filename = filetype === undefined ? name : `${name}.${filetype.ext}`;
                        localVarFormParams.append(name, data, filename);
                    }
                    else if ("name" in data) {
                        // File instances in browsers and Node.js have the
                        // "name" property "Duck typing" files to handle browser
                        // File class or Node.js File class
                        // Web: https://developer.mozilla.org/en-US/docs/Web/API/File
                        // Node.js: https://nodejs.org/api/buffer.html#new-bufferfilesources-filename-options
                        if ((0, common_1.isBrowser)()) {
                            // FormData in browser can accept File/Blob directly
                            localVarFormParams.append(name, data, data.name);
                        }
                        else {
                            // FormData in Node.js can only accept raw Buffer so convert before passing
                            const bytes = yield data.arrayBuffer();
                            const buffer = Buffer.from(bytes);
                            localVarFormParams.append(name, buffer, data.name);
                        }
                    }
                }
                else {
                    if (isPrimitiveType) {
                        /**
                         * FormData can only accept string or Blob so we need to convert
                         * non-string primitives to string. We also need to convert
                         */
                        if (typeof data === "object") {
                            localVarFormParams.append(name, JSON.stringify(data));
                        }
                        else {
                            localVarFormParams.append(name, data);
                        }
                    }
                    else {
                        if ((0, common_1.isBrowser)()) {
                            localVarFormParams.append(name, new Blob([JSON.stringify(data)], { type: "application/json" }));
                        }
                        else {
                            localVarFormParams.append(name, JSON.stringify(data), { type: "application/json", filename: "data.json" });
                        }
                    }
                }
            });
            if (!(0, common_1.isBrowser)())
                Object.assign(localVarHeaderParameter, localVarFormParams.getHeaders());
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            if (chunkSize !== undefined) {
                localVarQueryParameter['chunk_size'] = chunkSize;
            }
            if (chunkOverlap !== undefined) {
                localVarQueryParameter['chunk_overlap'] = chunkOverlap;
            }
            if (skipEmbeddingGeneration !== undefined) {
                localVarQueryParameter['skip_embedding_generation'] = skipEmbeddingGeneration;
            }
            if (setPageAsBoundary !== undefined) {
                localVarQueryParameter['set_page_as_boundary'] = setPageAsBoundary;
            }
            if (embeddingModel !== undefined) {
                localVarQueryParameter['embedding_model'] = embeddingModel;
            }
            if (useOcr !== undefined) {
                localVarQueryParameter['use_ocr'] = useOcr;
            }
            if (generateSparseVectors !== undefined) {
                localVarQueryParameter['generate_sparse_vectors'] = generateSparseVectors;
            }
            if (prependFilenameToChunks !== undefined) {
                localVarQueryParameter['prepend_filename_to_chunks'] = prependFilenameToChunks;
            }
            if (maxItemsPerChunk !== undefined) {
                localVarQueryParameter['max_items_per_chunk'] = maxItemsPerChunk;
            }
            if (parsePdfTablesWithOcr !== undefined) {
                localVarQueryParameter['parse_pdf_tables_with_ocr'] = parsePdfTablesWithOcr;
            }
            if (detectAudioLanguage !== undefined) {
                localVarQueryParameter['detect_audio_language'] = detectAudioLanguage;
            }
            if (transcriptionService !== undefined) {
                localVarQueryParameter['transcription_service'] = transcriptionService;
            }
            if (includeSpeakerLabels !== undefined) {
                localVarQueryParameter['include_speaker_labels'] = includeSpeakerLabels;
            }
            if (mediaType !== undefined) {
                localVarQueryParameter['media_type'] = mediaType;
            }
            if (splitRows !== undefined) {
                localVarQueryParameter['split_rows'] = splitRows;
            }
            if (enableColdStorage !== undefined) {
                localVarQueryParameter['enable_cold_storage'] = enableColdStorage;
            }
            if (hotStorageTimeToLive !== undefined) {
                localVarQueryParameter['hot_storage_time_to_live'] = hotStorageTimeToLive;
            }
            if (generateChunksOnly !== undefined) {
                localVarQueryParameter['generate_chunks_only'] = generateChunksOnly;
            }
            if (storeFileOnly !== undefined) {
                localVarQueryParameter['store_file_only'] = storeFileOnly;
            }
            if (file !== undefined) {
                yield addFormParam('file', file, true, true);
            }
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = localVarFormParams;
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: bodyCreateUploadFileUploadfilePost,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/uploadfile',
                httpMethod: 'POST'
            });
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @summary Create Upload File From Url
         * @param {UploadFileFromUrlInput} uploadFileFromUrlInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFromUrl: (uploadFileFromUrlInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'uploadFileFromUrlInput' is not null or undefined
            (0, common_1.assertParamExists)('uploadFromUrl', 'uploadFileFromUrlInput', uploadFileFromUrlInput);
            const localVarPath = `/upload_file_from_url`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: uploadFileFromUrlInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/upload_file_from_url',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(uploadFileFromUrlInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Carbon supports multiple models for use in generating embeddings for files. For images, we support Vertex AI\'s multimodal model; for text, we support OpenAI\'s `text-embedding-ada-002` and Cohere\'s embed-multilingual-v3.0. The model can be specified via the `embedding_model` parameter (in the POST body for `/embeddings`, and a query  parameter in `/uploadfile`). If no model is supplied, the `text-embedding-ada-002` is used by default. When performing embedding queries, embeddings from files that used the specified model will be considered in the query. For example, if files A and B have embeddings generated with `OPENAI`, and files C and D have embeddings generated with `COHERE_MULTILINGUAL_V3`, then by default, queries will only consider files A and B. If `COHERE_MULTILINGUAL_V3` is specified as the `embedding_model` in `/embeddings`, then only files C and D will be considered. Make sure that the set of all files you want considered for a query have embeddings generated via the same model. For now, **do not** set `VERTEX_MULTIMODAL` as an `embedding_model`. This model is used automatically by Carbon when it detects an image file.
         * @summary Create Raw Text
         * @param {RawTextInput} rawTextInput
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadText: (rawTextInput, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'rawTextInput' is not null or undefined
            (0, common_1.assertParamExists)('uploadText', 'rawTextInput', rawTextInput);
            const localVarPath = `/upload_text`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = configuration && !(0, common_1.isBrowser)() ? { "User-Agent": configuration.userAgent } : {};
            const localVarQueryParameter = {};
            // authentication accessToken required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "accessToken", configuration, prefix: "Token " });
            // authentication apiKey required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "authorization", keyParamName: "apiKey", configuration, prefix: "Bearer " });
            // authentication customerId required
            yield (0, common_1.setApiKeyToObject)({ object: localVarHeaderParameter, key: "customer-id", keyParamName: "customerId", configuration });
            localVarHeaderParameter['Content-Type'] = 'application/json';
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            (0, requestBeforeHook_1.requestBeforeHook)({
                requestBody: rawTextInput,
                queryParameters: localVarQueryParameter,
                requestConfig: localVarRequestOptions,
                path: localVarPath,
                configuration,
                pathTemplate: '/upload_text',
                httpMethod: 'POST'
            });
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(rawTextInput, localVarRequestOptions, configuration);
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.FilesApiAxiosParamCreator = FilesApiAxiosParamCreator;
/**
 * FilesApi - functional programming interface
 * @export
 */
const FilesApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.FilesApiAxiosParamCreator)(configuration);
    return {
        /**
         * A tag is a key-value pair that can be added to a file. This pair can then be used for searches (e.g. embedding searches) in order to narrow down the scope of the search. A file can have any number of tags. The following are reserved keys that cannot be used: - db_embedding_id - organization_id - user_id - organization_user_file_id  Carbon currently supports two data types for tag values - `string` and `list<string>`. Keys can only be `string`. If values other than `string` and `list<string>` are used, they\'re automatically converted to strings (e.g. 4 will become \"4\").
         * @summary Create File Tags
         * @param {FilesApiCreateUserFileTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserFileTags(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const organizationUserFileTagCreate = {
                    tags: requestParameters.tags,
                    organization_user_file_id: requestParameters.organization_user_file_id
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.createUserFileTags(organizationUserFileTagCreate, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete File Endpoint
         * @param {FilesApiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        delete(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.delete(requestParameters.fileId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete File Tags
         * @param {FilesApiDeleteFileTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFileTags(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const organizationUserFileTagsRemove = {
                    tags: requestParameters.tags,
                    organization_user_file_id: requestParameters.organization_user_file_id
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteFileTags(organizationUserFileTagsRemove, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete Files Endpoint
         * @param {FilesApiDeleteManyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteMany(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const deleteFilesQueryInput = {
                    file_ids: requestParameters.file_ids,
                    sync_statuses: requestParameters.sync_statuses,
                    delete_non_synced_only: requestParameters.delete_non_synced_only,
                    send_webhook: requestParameters.send_webhook,
                    delete_child_files: requestParameters.delete_child_files
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteMany(deleteFilesQueryInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Delete Files V2 Endpoint
         * @param {FilesApiDeleteV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV2(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const deleteFilesV2QueryInput = {
                    filters: requestParameters.filters,
                    send_webhook: requestParameters.send_webhook,
                    preserve_file_record: requestParameters.preserve_file_record
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.deleteV2(deleteFilesV2QueryInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * This route is deprecated. Use `/user_files_v2` instead.
         * @summary Parsed File
         * @param {FilesApiGetParsedFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getParsedFile(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getParsedFile(requestParameters.fileId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * This route is deprecated. Use `/user_files_v2` instead.
         * @summary Raw File
         * @param {FilesApiGetRawFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRawFile(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getRawFile(requestParameters.fileId, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Modify Cold Storage Parameters
         * @param {FilesApiModifyColdStorageParametersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyColdStorageParameters(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const modifyColdStorageParametersQueryInput = {
                    filters: requestParameters.filters,
                    enable_cold_storage: requestParameters.enable_cold_storage,
                    hot_storage_time_to_live: requestParameters.hot_storage_time_to_live
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.modifyColdStorageParameters(modifyColdStorageParametersQueryInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Move To Hot Storage
         * @param {FilesApiMoveToHotStorageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveToHotStorage(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const moveToHotStorageQueryInput = {
                    filters: requestParameters.filters
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.moveToHotStorage(moveToHotStorageQueryInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * For pre-filtering documents, using `tags_v2` is preferred to using `tags` (which is now deprecated). If both `tags_v2` and `tags` are specified, `tags` is ignored. `tags_v2` enables building complex filters through the use of \"AND\", \"OR\", and negation logic. Take the below input as an example: ```json {     \"OR\": [         {             \"key\": \"subject\",             \"value\": \"holy-bible\",             \"negate\": false         },         {             \"key\": \"person-of-interest\",             \"value\": \"jesus christ\",             \"negate\": false         },         {             \"key\": \"genre\",             \"value\": \"religion\",             \"negate\": true         }         {             \"AND\": [                 {                     \"key\": \"subject\",                     \"value\": \"tao-te-ching\",                     \"negate\": false                 },                 {                     \"key\": \"author\",                     \"value\": \"lao-tzu\",                     \"negate\": false                 }             ]         }     ] } ``` In this case, files will be filtered such that: 1. \"subject\" = \"holy-bible\" OR 2. \"person-of-interest\" = \"jesus christ\" OR 3. \"genre\" != \"religion\" OR 4. \"subject\" = \"tao-te-ching\" AND \"author\" = \"lao-tzu\"  Note that the top level of the query must be either an \"OR\" or \"AND\" array. Currently, nesting is limited to 3. For tag blocks (those with \"key\", \"value\", and \"negate\" keys), the following typing rules apply: 1. \"key\" isn\'t optional and must be a `string` 2. \"value\" isn\'t optional and can be `any` or list[`any`] 3. \"negate\" is optional and must be `true` or `false`. If present and `true`, then the filter block is negated in the resulting query. It is `false` by default.
         * @summary User Files V2
         * @param {FilesApiQueryUserFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryUserFiles(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const organizationUserFilesToSyncQueryInput = {
                    pagination: requestParameters.pagination,
                    order_by: requestParameters.order_by,
                    order_dir: requestParameters.order_dir,
                    filters: requestParameters.filters,
                    include_raw_file: requestParameters.include_raw_file,
                    include_parsed_text_file: requestParameters.include_parsed_text_file,
                    include_additional_files: requestParameters.include_additional_files,
                    presigned_url_expiry_time_seconds: requestParameters.presigned_url_expiry_time_seconds
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryUserFiles(organizationUserFilesToSyncQueryInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * This route is deprecated. Use `/user_files_v2` instead.
         * @summary User Files
         * @param {FilesApiQueryUserFilesDeprecatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        queryUserFilesDeprecated(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const organizationUserFilesToSyncQueryInput = {
                    pagination: requestParameters.pagination,
                    order_by: requestParameters.order_by,
                    order_dir: requestParameters.order_dir,
                    filters: requestParameters.filters,
                    include_raw_file: requestParameters.include_raw_file,
                    include_parsed_text_file: requestParameters.include_parsed_text_file,
                    include_additional_files: requestParameters.include_additional_files,
                    presigned_url_expiry_time_seconds: requestParameters.presigned_url_expiry_time_seconds
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.queryUserFilesDeprecated(organizationUserFilesToSyncQueryInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Resync File
         * @param {FilesApiResyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resync(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const resyncFileQueryInput = {
                    file_id: requestParameters.file_id,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    force_embedding_generation: requestParameters.force_embedding_generation,
                    skip_file_processing: requestParameters.skip_file_processing
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.resync(resyncFileQueryInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * This endpoint is used to directly upload local files to Carbon. The `POST` request should be a multipart form request. Note that the `set_page_as_boundary` query parameter is applicable only to PDFs for now. When this value is set, PDF chunks are at most one page long. Additional information can be retrieved for each chunk, however, namely the coordinates of the bounding box around the chunk (this can be used for things like text highlighting). Following is a description of all possible query parameters: - `chunk_size`: the chunk size (in tokens) applied when splitting the document - `chunk_overlap`: the chunk overlap (in tokens) applied when splitting the document - `skip_embedding_generation`: whether or not to skip the generation of chunks and embeddings - `set_page_as_boundary`: described above - `embedding_model`: the model used to generate embeddings for the document chunks - `use_ocr`: whether or not to use OCR as a preprocessing step prior to generating chunks. Valid for PDFs, JPEGs, and PNGs - `generate_sparse_vectors`: whether or not to generate sparse vectors for the file. Required for hybrid search. - `prepend_filename_to_chunks`: whether or not to prepend the filename to the chunk text   Carbon supports multiple models for use in generating embeddings for files. For images, we support Vertex AI\'s multimodal model; for text, we support OpenAI\'s `text-embedding-ada-002` and Cohere\'s embed-multilingual-v3.0. The model can be specified via the `embedding_model` parameter (in the POST body for `/embeddings`, and a query  parameter in `/uploadfile`). If no model is supplied, the `text-embedding-ada-002` is used by default. When performing embedding queries, embeddings from files that used the specified model will be considered in the query. For example, if files A and B have embeddings generated with `OPENAI`, and files C and D have embeddings generated with `COHERE_MULTILINGUAL_V3`, then by default, queries will only consider files A and B. If `COHERE_MULTILINGUAL_V3` is specified as the `embedding_model` in `/embeddings`, then only files C and D will be considered. Make sure that the set of all files you want considered for a query have embeddings generated via the same model. For now, **do not** set `VERTEX_MULTIMODAL` as an `embedding_model`. This model is used automatically by Carbon when it detects an image file.
         * @summary Create Upload File
         * @param {FilesApiUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const bodyCreateUploadFileUploadfilePost = {
                    file: requestParameters.file
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.upload(requestParameters.file, bodyCreateUploadFileUploadfilePost, requestParameters.chunkSize, requestParameters.chunkOverlap, requestParameters.skipEmbeddingGeneration, requestParameters.setPageAsBoundary, requestParameters.embeddingModel, requestParameters.useOcr, requestParameters.generateSparseVectors, requestParameters.prependFilenameToChunks, requestParameters.maxItemsPerChunk, requestParameters.parsePdfTablesWithOcr, requestParameters.detectAudioLanguage, requestParameters.transcriptionService, requestParameters.includeSpeakerLabels, requestParameters.mediaType, requestParameters.splitRows, requestParameters.enableColdStorage, requestParameters.hotStorageTimeToLive, requestParameters.generateChunksOnly, requestParameters.storeFileOnly, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @summary Create Upload File From Url
         * @param {FilesApiUploadFromUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFromUrl(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const uploadFileFromUrlInput = {
                    url: requestParameters.url,
                    file_name: requestParameters.file_name,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    set_page_as_boundary: requestParameters.set_page_as_boundary,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    use_textract: requestParameters.use_textract,
                    prepend_filename_to_chunks: requestParameters.prepend_filename_to_chunks,
                    max_items_per_chunk: requestParameters.max_items_per_chunk,
                    parse_pdf_tables_with_ocr: requestParameters.parse_pdf_tables_with_ocr,
                    detect_audio_language: requestParameters.detect_audio_language,
                    transcription_service: requestParameters.transcription_service,
                    include_speaker_labels: requestParameters.include_speaker_labels,
                    media_type: requestParameters.media_type,
                    split_rows: requestParameters.split_rows,
                    cold_storage_params: requestParameters.cold_storage_params,
                    generate_chunks_only: requestParameters.generate_chunks_only,
                    store_file_only: requestParameters.store_file_only
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadFromUrl(uploadFileFromUrlInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Carbon supports multiple models for use in generating embeddings for files. For images, we support Vertex AI\'s multimodal model; for text, we support OpenAI\'s `text-embedding-ada-002` and Cohere\'s embed-multilingual-v3.0. The model can be specified via the `embedding_model` parameter (in the POST body for `/embeddings`, and a query  parameter in `/uploadfile`). If no model is supplied, the `text-embedding-ada-002` is used by default. When performing embedding queries, embeddings from files that used the specified model will be considered in the query. For example, if files A and B have embeddings generated with `OPENAI`, and files C and D have embeddings generated with `COHERE_MULTILINGUAL_V3`, then by default, queries will only consider files A and B. If `COHERE_MULTILINGUAL_V3` is specified as the `embedding_model` in `/embeddings`, then only files C and D will be considered. Make sure that the set of all files you want considered for a query have embeddings generated via the same model. For now, **do not** set `VERTEX_MULTIMODAL` as an `embedding_model`. This model is used automatically by Carbon when it detects an image file.
         * @summary Create Raw Text
         * @param {FilesApiUploadTextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadText(requestParameters, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const rawTextInput = {
                    contents: requestParameters.contents,
                    name: requestParameters.name,
                    chunk_size: requestParameters.chunk_size,
                    chunk_overlap: requestParameters.chunk_overlap,
                    skip_embedding_generation: requestParameters.skip_embedding_generation,
                    overwrite_file_id: requestParameters.overwrite_file_id,
                    embedding_model: requestParameters.embedding_model,
                    generate_sparse_vectors: requestParameters.generate_sparse_vectors,
                    cold_storage_params: requestParameters.cold_storage_params,
                    generate_chunks_only: requestParameters.generate_chunks_only,
                    store_file_only: requestParameters.store_file_only
                };
                const localVarAxiosArgs = yield localVarAxiosParamCreator.uploadText(rawTextInput, options);
                return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
exports.FilesApiFp = FilesApiFp;
/**
 * FilesApi - factory interface
 * @export
 */
const FilesApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.FilesApiFp)(configuration);
    return {
        /**
         * A tag is a key-value pair that can be added to a file. This pair can then be used for searches (e.g. embedding searches) in order to narrow down the scope of the search. A file can have any number of tags. The following are reserved keys that cannot be used: - db_embedding_id - organization_id - user_id - organization_user_file_id  Carbon currently supports two data types for tag values - `string` and `list<string>`. Keys can only be `string`. If values other than `string` and `list<string>` are used, they\'re automatically converted to strings (e.g. 4 will become \"4\").
         * @summary Create File Tags
         * @param {FilesApiCreateUserFileTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserFileTags(requestParameters, options) {
            return localVarFp.createUserFileTags(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete File Endpoint
         * @param {FilesApiDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        delete(requestParameters, options) {
            return localVarFp.delete(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete File Tags
         * @param {FilesApiDeleteFileTagsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFileTags(requestParameters, options) {
            return localVarFp.deleteFileTags(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Files Endpoint
         * @param {FilesApiDeleteManyRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        deleteMany(requestParameters, options) {
            return localVarFp.deleteMany(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Delete Files V2 Endpoint
         * @param {FilesApiDeleteV2Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteV2(requestParameters, options) {
            return localVarFp.deleteV2(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * This route is deprecated. Use `/user_files_v2` instead.
         * @summary Parsed File
         * @param {FilesApiGetParsedFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getParsedFile(requestParameters, options) {
            return localVarFp.getParsedFile(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * This route is deprecated. Use `/user_files_v2` instead.
         * @summary Raw File
         * @param {FilesApiGetRawFileRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getRawFile(requestParameters, options) {
            return localVarFp.getRawFile(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Modify Cold Storage Parameters
         * @param {FilesApiModifyColdStorageParametersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modifyColdStorageParameters(requestParameters, options) {
            return localVarFp.modifyColdStorageParameters(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Move To Hot Storage
         * @param {FilesApiMoveToHotStorageRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        moveToHotStorage(requestParameters, options) {
            return localVarFp.moveToHotStorage(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * For pre-filtering documents, using `tags_v2` is preferred to using `tags` (which is now deprecated). If both `tags_v2` and `tags` are specified, `tags` is ignored. `tags_v2` enables building complex filters through the use of \"AND\", \"OR\", and negation logic. Take the below input as an example: ```json {     \"OR\": [         {             \"key\": \"subject\",             \"value\": \"holy-bible\",             \"negate\": false         },         {             \"key\": \"person-of-interest\",             \"value\": \"jesus christ\",             \"negate\": false         },         {             \"key\": \"genre\",             \"value\": \"religion\",             \"negate\": true         }         {             \"AND\": [                 {                     \"key\": \"subject\",                     \"value\": \"tao-te-ching\",                     \"negate\": false                 },                 {                     \"key\": \"author\",                     \"value\": \"lao-tzu\",                     \"negate\": false                 }             ]         }     ] } ``` In this case, files will be filtered such that: 1. \"subject\" = \"holy-bible\" OR 2. \"person-of-interest\" = \"jesus christ\" OR 3. \"genre\" != \"religion\" OR 4. \"subject\" = \"tao-te-ching\" AND \"author\" = \"lao-tzu\"  Note that the top level of the query must be either an \"OR\" or \"AND\" array. Currently, nesting is limited to 3. For tag blocks (those with \"key\", \"value\", and \"negate\" keys), the following typing rules apply: 1. \"key\" isn\'t optional and must be a `string` 2. \"value\" isn\'t optional and can be `any` or list[`any`] 3. \"negate\" is optional and must be `true` or `false`. If present and `true`, then the filter block is negated in the resulting query. It is `false` by default.
         * @summary User Files V2
         * @param {FilesApiQueryUserFilesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        queryUserFiles(requestParameters, options) {
            return localVarFp.queryUserFiles(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * This route is deprecated. Use `/user_files_v2` instead.
         * @summary User Files
         * @param {FilesApiQueryUserFilesDeprecatedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        queryUserFilesDeprecated(requestParameters, options) {
            return localVarFp.queryUserFilesDeprecated(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Resync File
         * @param {FilesApiResyncRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resync(requestParameters, options) {
            return localVarFp.resync(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint is used to directly upload local files to Carbon. The `POST` request should be a multipart form request. Note that the `set_page_as_boundary` query parameter is applicable only to PDFs for now. When this value is set, PDF chunks are at most one page long. Additional information can be retrieved for each chunk, however, namely the coordinates of the bounding box around the chunk (this can be used for things like text highlighting). Following is a description of all possible query parameters: - `chunk_size`: the chunk size (in tokens) applied when splitting the document - `chunk_overlap`: the chunk overlap (in tokens) applied when splitting the document - `skip_embedding_generation`: whether or not to skip the generation of chunks and embeddings - `set_page_as_boundary`: described above - `embedding_model`: the model used to generate embeddings for the document chunks - `use_ocr`: whether or not to use OCR as a preprocessing step prior to generating chunks. Valid for PDFs, JPEGs, and PNGs - `generate_sparse_vectors`: whether or not to generate sparse vectors for the file. Required for hybrid search. - `prepend_filename_to_chunks`: whether or not to prepend the filename to the chunk text   Carbon supports multiple models for use in generating embeddings for files. For images, we support Vertex AI\'s multimodal model; for text, we support OpenAI\'s `text-embedding-ada-002` and Cohere\'s embed-multilingual-v3.0. The model can be specified via the `embedding_model` parameter (in the POST body for `/embeddings`, and a query  parameter in `/uploadfile`). If no model is supplied, the `text-embedding-ada-002` is used by default. When performing embedding queries, embeddings from files that used the specified model will be considered in the query. For example, if files A and B have embeddings generated with `OPENAI`, and files C and D have embeddings generated with `COHERE_MULTILINGUAL_V3`, then by default, queries will only consider files A and B. If `COHERE_MULTILINGUAL_V3` is specified as the `embedding_model` in `/embeddings`, then only files C and D will be considered. Make sure that the set of all files you want considered for a query have embeddings generated via the same model. For now, **do not** set `VERTEX_MULTIMODAL` as an `embedding_model`. This model is used automatically by Carbon when it detects an image file.
         * @summary Create Upload File
         * @param {FilesApiUploadRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        upload(requestParameters, options) {
            return localVarFp.upload(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @summary Create Upload File From Url
         * @param {FilesApiUploadFromUrlRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadFromUrl(requestParameters, options) {
            return localVarFp.uploadFromUrl(requestParameters, options).then((request) => request(axios, basePath));
        },
        /**
         * Carbon supports multiple models for use in generating embeddings for files. For images, we support Vertex AI\'s multimodal model; for text, we support OpenAI\'s `text-embedding-ada-002` and Cohere\'s embed-multilingual-v3.0. The model can be specified via the `embedding_model` parameter (in the POST body for `/embeddings`, and a query  parameter in `/uploadfile`). If no model is supplied, the `text-embedding-ada-002` is used by default. When performing embedding queries, embeddings from files that used the specified model will be considered in the query. For example, if files A and B have embeddings generated with `OPENAI`, and files C and D have embeddings generated with `COHERE_MULTILINGUAL_V3`, then by default, queries will only consider files A and B. If `COHERE_MULTILINGUAL_V3` is specified as the `embedding_model` in `/embeddings`, then only files C and D will be considered. Make sure that the set of all files you want considered for a query have embeddings generated via the same model. For now, **do not** set `VERTEX_MULTIMODAL` as an `embedding_model`. This model is used automatically by Carbon when it detects an image file.
         * @summary Create Raw Text
         * @param {FilesApiUploadTextRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadText(requestParameters, options) {
            return localVarFp.uploadText(requestParameters, options).then((request) => request(axios, basePath));
        },
    };
};
exports.FilesApiFactory = FilesApiFactory;
/**
 * FilesApiGenerated - object-oriented interface
 * @export
 * @class FilesApiGenerated
 * @extends {BaseAPI}
 */
class FilesApiGenerated extends base_1.BaseAPI {
    /**
     * A tag is a key-value pair that can be added to a file. This pair can then be used for searches (e.g. embedding searches) in order to narrow down the scope of the search. A file can have any number of tags. The following are reserved keys that cannot be used: - db_embedding_id - organization_id - user_id - organization_user_file_id  Carbon currently supports two data types for tag values - `string` and `list<string>`. Keys can only be `string`. If values other than `string` and `list<string>` are used, they\'re automatically converted to strings (e.g. 4 will become \"4\").
     * @summary Create File Tags
     * @param {FilesApiCreateUserFileTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    createUserFileTags(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).createUserFileTags(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete File Endpoint
     * @param {FilesApiDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    delete(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).delete(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete File Tags
     * @param {FilesApiDeleteFileTagsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    deleteFileTags(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).deleteFileTags(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Files Endpoint
     * @param {FilesApiDeleteManyRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    deleteMany(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).deleteMany(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Delete Files V2 Endpoint
     * @param {FilesApiDeleteV2Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    deleteV2(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).deleteV2(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This route is deprecated. Use `/user_files_v2` instead.
     * @summary Parsed File
     * @param {FilesApiGetParsedFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    getParsedFile(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).getParsedFile(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This route is deprecated. Use `/user_files_v2` instead.
     * @summary Raw File
     * @param {FilesApiGetRawFileRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    getRawFile(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).getRawFile(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Modify Cold Storage Parameters
     * @param {FilesApiModifyColdStorageParametersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    modifyColdStorageParameters(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).modifyColdStorageParameters(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Move To Hot Storage
     * @param {FilesApiMoveToHotStorageRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    moveToHotStorage(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).moveToHotStorage(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * For pre-filtering documents, using `tags_v2` is preferred to using `tags` (which is now deprecated). If both `tags_v2` and `tags` are specified, `tags` is ignored. `tags_v2` enables building complex filters through the use of \"AND\", \"OR\", and negation logic. Take the below input as an example: ```json {     \"OR\": [         {             \"key\": \"subject\",             \"value\": \"holy-bible\",             \"negate\": false         },         {             \"key\": \"person-of-interest\",             \"value\": \"jesus christ\",             \"negate\": false         },         {             \"key\": \"genre\",             \"value\": \"religion\",             \"negate\": true         }         {             \"AND\": [                 {                     \"key\": \"subject\",                     \"value\": \"tao-te-ching\",                     \"negate\": false                 },                 {                     \"key\": \"author\",                     \"value\": \"lao-tzu\",                     \"negate\": false                 }             ]         }     ] } ``` In this case, files will be filtered such that: 1. \"subject\" = \"holy-bible\" OR 2. \"person-of-interest\" = \"jesus christ\" OR 3. \"genre\" != \"religion\" OR 4. \"subject\" = \"tao-te-ching\" AND \"author\" = \"lao-tzu\"  Note that the top level of the query must be either an \"OR\" or \"AND\" array. Currently, nesting is limited to 3. For tag blocks (those with \"key\", \"value\", and \"negate\" keys), the following typing rules apply: 1. \"key\" isn\'t optional and must be a `string` 2. \"value\" isn\'t optional and can be `any` or list[`any`] 3. \"negate\" is optional and must be `true` or `false`. If present and `true`, then the filter block is negated in the resulting query. It is `false` by default.
     * @summary User Files V2
     * @param {FilesApiQueryUserFilesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    queryUserFiles(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).queryUserFiles(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This route is deprecated. Use `/user_files_v2` instead.
     * @summary User Files
     * @param {FilesApiQueryUserFilesDeprecatedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    queryUserFilesDeprecated(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).queryUserFilesDeprecated(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Resync File
     * @param {FilesApiResyncRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    resync(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).resync(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * This endpoint is used to directly upload local files to Carbon. The `POST` request should be a multipart form request. Note that the `set_page_as_boundary` query parameter is applicable only to PDFs for now. When this value is set, PDF chunks are at most one page long. Additional information can be retrieved for each chunk, however, namely the coordinates of the bounding box around the chunk (this can be used for things like text highlighting). Following is a description of all possible query parameters: - `chunk_size`: the chunk size (in tokens) applied when splitting the document - `chunk_overlap`: the chunk overlap (in tokens) applied when splitting the document - `skip_embedding_generation`: whether or not to skip the generation of chunks and embeddings - `set_page_as_boundary`: described above - `embedding_model`: the model used to generate embeddings for the document chunks - `use_ocr`: whether or not to use OCR as a preprocessing step prior to generating chunks. Valid for PDFs, JPEGs, and PNGs - `generate_sparse_vectors`: whether or not to generate sparse vectors for the file. Required for hybrid search. - `prepend_filename_to_chunks`: whether or not to prepend the filename to the chunk text   Carbon supports multiple models for use in generating embeddings for files. For images, we support Vertex AI\'s multimodal model; for text, we support OpenAI\'s `text-embedding-ada-002` and Cohere\'s embed-multilingual-v3.0. The model can be specified via the `embedding_model` parameter (in the POST body for `/embeddings`, and a query  parameter in `/uploadfile`). If no model is supplied, the `text-embedding-ada-002` is used by default. When performing embedding queries, embeddings from files that used the specified model will be considered in the query. For example, if files A and B have embeddings generated with `OPENAI`, and files C and D have embeddings generated with `COHERE_MULTILINGUAL_V3`, then by default, queries will only consider files A and B. If `COHERE_MULTILINGUAL_V3` is specified as the `embedding_model` in `/embeddings`, then only files C and D will be considered. Make sure that the set of all files you want considered for a query have embeddings generated via the same model. For now, **do not** set `VERTEX_MULTIMODAL` as an `embedding_model`. This model is used automatically by Carbon when it detects an image file.
     * @summary Create Upload File
     * @param {FilesApiUploadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    upload(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).upload(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @summary Create Upload File From Url
     * @param {FilesApiUploadFromUrlRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    uploadFromUrl(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).uploadFromUrl(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Carbon supports multiple models for use in generating embeddings for files. For images, we support Vertex AI\'s multimodal model; for text, we support OpenAI\'s `text-embedding-ada-002` and Cohere\'s embed-multilingual-v3.0. The model can be specified via the `embedding_model` parameter (in the POST body for `/embeddings`, and a query  parameter in `/uploadfile`). If no model is supplied, the `text-embedding-ada-002` is used by default. When performing embedding queries, embeddings from files that used the specified model will be considered in the query. For example, if files A and B have embeddings generated with `OPENAI`, and files C and D have embeddings generated with `COHERE_MULTILINGUAL_V3`, then by default, queries will only consider files A and B. If `COHERE_MULTILINGUAL_V3` is specified as the `embedding_model` in `/embeddings`, then only files C and D will be considered. Make sure that the set of all files you want considered for a query have embeddings generated via the same model. For now, **do not** set `VERTEX_MULTIMODAL` as an `embedding_model`. This model is used automatically by Carbon when it detects an image file.
     * @summary Create Raw Text
     * @param {FilesApiUploadTextRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof FilesApiGenerated
     */
    uploadText(requestParameters, options) {
        return (0, exports.FilesApiFp)(this.configuration).uploadText(requestParameters, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.FilesApiGenerated = FilesApiGenerated;
